module.exports = __webpack_public_path__ + "media/img/apple-touch-icon-iphone-b22ccd9f0b5c76738df6a1c400073f96.png";